export const INVOICES_VALIDATION_RULES = {
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/invoicesValidationRules.js